import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { BatchTracingSpec } from '../batch-tracing-spec'
import { BatchTracingSpecDetailComponent } from '../batch-tracing-spec-detail/batch-tracing-spec-detail.component'

@Component({
  selector: 'app-batch-tracing-spec-detail-side',
  templateUrl: './batch-tracing-spec-detail-side.component.html',
  styleUrls: ['./batch-tracing-spec-detail-side.component.scss'],
  imports: [BatchTracingSpecDetailComponent],
})
export class BatchTracingSpecDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  public spec: BatchTracingSpec
  private route = inject(ActivatedRoute)
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.spec = this.route.snapshot.data['spec']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
